/* eslint-disable max-len */
export const FollowedBrands = "/marki";
export const BrandDetails = { url: "/marka/%7Bname%7D", type: undefined as { name: string | number; } };
export const BrandDetailsCashback = { url: "/marka/%7Bname%7D/cashback", type: undefined as { name: string | number; } };
export const DetailsFlyersPromotions = { url: "/marka/%7Bname%7D/gazetka-promocyjna", type: undefined as { name: string | number; } };
export const Brand = { url: "/api/brand/%7Baction%7D", type: undefined as { action: string | number; } };
